<template>
  <div>
    <div v-if="!store.insurances">
      <div class="deck deck--grey pa-1">
        {{t('MessageNoInsurances')}}
      </div>
    </div>
    <div v-if="store.insurances" class="deck deck--grey py-3 px-4">
      <section>
        <div class="grid">
          <div class="grid__col grid__col--4 grid__col--xs-3 grid__col--sm-2">
            <div role="presentation" class="headline image">
              <figure>
                <img src="./../../../../static/samlemappe.svg" alt="">
              </figure>
            </div>
          </div>
          <div v-if="!store.insuranceQues" class="grid__col grid__col--8 grid__col--xs-9 grid__col--sm-4">
            <h2 class="headline-3">{{t('InsurancesTitle')}}</h2>
            <p v-if="store.company">
              {{store.company.name}}
              {{store.company.address}}
              {{store.company.postalCode}}
              {{store.company.city}}
            </p>
          </div>
          <div v-if="store.insuranceQues" class="grid__col grid__col--4 grid__col--xs-3 grid__col--sm-9">
            <h2 class="headline-3">{{t('InsurancesTitle')}}</h2>
            <p v-if="store.company">
              {{store.company.name}}
              {{store.company.address}}
              {{store.company.postalCode}}
              {{store.company.city}}
            </p>
          </div>
          <div v-if="!store.insuranceQues" class="grid__col grid__col--12 grid__col--xs-12 grid__col--sm-4">
            <p>
              {{t('InsurancesText')}}
            </p>
          </div>
          <div v-if="store.insuranceQues" class="grid__col grid__col--12 grid__col--xs-12 grid__col--sm-10">
            <div class="headline-5">
              {{t('InsurancesTextGB')}}
            </div>
          </div>
          <div v-if="store.insuranceQues" class="grid__col grid__col--12 grid__col--xs-12 grid__col--sm-10">
            <div v-html="t('InsurancesTextGBLink')">
            </div>
          </div>
        </div>
        <InsuranceItem
          v-for="insurance in store.insurances"
          @toogle="doHandleToogle(insurance)"
          :key="insurance.id"
          :insurance="insurance"
          >
        </InsuranceItem>
      </section>
      <section v-if="store.insuranceQues" class="insurance borderline borderline--left my-1 c--white">
        <div class="grid">
          <div class="grid__col grid__col--12 py-1 px-2">
            <div class="form__field form__field--checkbox mb-0">
              <input class="form__item" type="checkbox" id="uuid" v-model="checked" @click=doOpenIns>
              <label class="form__label form__label--with-headline label-indent" for="uuid">
                <h3 class="headline-4">
                  <div class="form__label-text t--bold">{{t('InsurancesTextPlaceholder')}}</div>
                </h3>
              </label>
              <label>
                <span class="form__label__text_gb">{{t('InsurancePlaceHolder')}}</span>
              </label>
              <div v-if="inputInsurance" class="headline_gb">
                <input
                  class="gbInput"
                  id="textarea"
                  v-model="text"
                  @keyup="doNextIns(text)"
                  rows="3"
                  max-rows="6"
                  maxlength = "200"
                  >
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="!store.insuranceQues">
        <h2 class="headline-3">
          {{t('InsurancesHeadlineOtherChoose')}}
        </h2>
        <InsuranceItem
          v-for="insurance in store.optionalInsurances"
          @toogle="doHandleToogle(insurance)"
          :key="insurance.id"
          :insurance="insurance"
          >
        </InsuranceItem>
      </section>
      <div class="form__field">
        <button v-if="store.insuranceQues"
          class="button button--secondary"
          :class="[store.buttons[0].class, {'is-loading': isLoadingBack}]"
          :data-tealium="store.buttons[0]['data-tealium']"
          @click="goBack"
          >
          <span>
            {{t('InsurancesButtonBack')}}
          </span>
        </button>
        <button
          class="button button--primary"
          :class="[store.buttons[0].class, {'is-loading': isLoading}]"
          :data-tealium="store.buttons[0]['data-tealium']"
          @click="doNext">
          <span>
            {{t('InsurancesButtonSubmit')}}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import t from './../../../mixins/t.js'
import InsuranceItem from './InsuranceItem'

export default {
  name: 'Insurances',
  components: {
    InsuranceItem
  },
  mixins: [t],
  props: {
    cvr: {
      type: String
    }
  },
  data () {
    return {
      store: this.$parent.store,
      isLoading: false,
      isLoadingBack: false,
      inputInsurance: false,
      isCheckAll: false,
      checkExtraInsurance: false
    }
  },
  created () {
    let appCommercialGuide = document.getElementById('appCommercialGuide')
    if (appCommercialGuide) {
      appCommercialGuide.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'})
    }
    if (!this.store.insurances) {
      console.log('Insurances missing - begin again')
      this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(0) } })
    }
  },
  methods: {
    doHandleToogle (insurance) {
      insurance.selected = !insurance.selected
    },
    doNext () {
      this.isLoading = true
      this.$bus.$emit('app_getContact')
    },
    goBack () {
      this.isLoadingBack = true
      window.history.go(-1)
    },
    doNextIns (text) {
      let otherInsurances = ''
      otherInsurances = text
      this.checkExtraInsurance = true
      this.store.checkExtraInsurance = this.checkExtraInsurance
      this.store.otherInsurances = otherInsurances
    },
    doOpenIns () {
      this.isCheckAll = !this.isCheckAll
      if (this.isCheckAll) {
        this.inputInsurance = true
      } else {
        this.inputInsurance = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .headline.image img {
    max-width: 150px;
  }
  @media only screen and (max-width: 768px) {
    /* Make the image smaller for mobile view */
    .headline.image img {
      max-width: 75px;
    }
  }
  .headline_gb {
   margin-left: 45px;
   padding-left: 1.2rem;
  }
  .gbInput {
      height: 2.5rem;
      width: 40%;
      margin-bottom: 2%;
      margin-top: 1%;
      margin-left: 3px;
      padding-left: 1%;
      pointer-events: unset !important;
      font-size: 16px;
      padding-left: 1.2rem;
    }
  @media only screen and (max-width: 768px) {
    .gbInput {
      height: 2.5rem;
      width: 100%;
      margin-bottom: 2%;
      margin-top: 1%;
      margin-left: 3px;
      padding-left: 1%;
      pointer-events: unset !important;
      font-size: 16px;
    }
  }
  .form__label__text_gb{
    position: relative;
    border-radius: 0.375rem;
    left: 0.063rem;
    display: inline-block;
    margin-left: 47px;
    margin-top: 12px;
    margin-bottom: 20px;
    padding-left: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/insurances/Insurances.vue